import { render, staticRenderFns } from "./DashboardVisitor.vue?vue&type=template&id=56465b0c&scoped=true"
import script from "./DashboardVisitor.vue?vue&type=script&lang=js"
export * from "./DashboardVisitor.vue?vue&type=script&lang=js"
import style0 from "./DashboardVisitor.vue?vue&type=style&index=0&id=56465b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56465b0c",
  null
  
)

export default component.exports